import React from "react";
import {
    createStyles,
    Typography,
    Grid,
    IconButton,
    ImageList,
    ImageListItem,
    ImageListItemBar,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import imgNomina from "../../static/images/percentage.png";

const serviciosStyles = createStyles(() => ({
    root: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        overflow: "hidden",
    },
    paddingGrid: {
        marginBottom: "10px",
        padding: 20,
    },
    gridList: {
        width: 253,
        height: 280,
        padding: 20,
    },
    icon: {
        color: "rgba(255, 255, 255, 0.54)",
    },
    img: {
        width: 180,
        height: 205,
    },
}));

const tileData = [
    {
        img: imgNomina,
        title: "Nomina",
        url: "https://choucairtesting.sharepoint.com/sites/Intranet/SitePages/servicios-internos.aspx",
    },
];

const Servicios = () => {
    const classes = serviciosStyles();
    return (
        <Grid container style={classes.root}>
            <Grid style={classes.paddingGrid} item xs={12}>
                <Typography variant="h4" align="center">
                    Servicios
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <ImageList cellHeight={300} style={classes.gridList} spacing="30" cols={1}>
                    {tileData.map((tile) => (
                        <ImageListItem>
                            <a
                                href={tile.url}
                                target="_blank"
                                without
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={tile.img}
                                    style={classes.img}
                                    alt={tile.title}
                                />
                                <ImageListItemBar
                                    title={tile.title}
                                    actionIcon={
                                        <IconButton
                                            aria-label={`info about ${tile.title}`}
                                            style={classes.icon}
                                        >
                                            <InfoIcon link={tile.url} />
                                        </IconButton>
                                    }
                                />
                            </a>
                        </ImageListItem>
                    ))}
                </ImageList>
            </Grid>
        </Grid>
    );
};
export default Servicios;
